import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import useAuthRole from "../hooks/useAuthRole";

export default function AdminLayout() {
  const { roles } = useAuthRole();
  const canCashier = roles.cashier || roles.manager || roles.admin;
  const canManager = roles.manager || roles.admin;
  const isAdmin = !!roles.admin;

  const cardLinkStyle = ({ isActive }) =>
    `card text-center p-3 border-0 shadow-sm rounded-3 h-100 text-decoration-none ${
      isActive ? "bg-dark text-white" : "bg-light text-dark"
    }`;

  return (
    <div className="row g-3">
      {/* Sidebar */}
      <aside className="col-12 col-lg-4 col-xl-3">
        <div className="d-flex flex-column gap-4">
          {/* Section principale */}
          <div>
            <h6 className="text-uppercase text-muted fw-bold mb-2">
              Tableau de bord
            </h6>
            <div className="row row-cols-2 g-2">
              <div className="col">
                <NavLink end to="/admin" className={cardLinkStyle}>
                  Dashboard
                </NavLink>
              </div>
              <div className="col">
                <NavLink to="orders" className={cardLinkStyle}>
                  Commandes
                </NavLink>
              </div>
              <div className="col">
                <NavLink to="categories" className={cardLinkStyle}>
                  Catégories
                </NavLink>
              </div>
              <div className="col">
                <NavLink to="wines" className={cardLinkStyle}>
                  Vins et autres
                </NavLink>
              </div>
            </div>
          </div>

          {/* POS */}
          {canCashier && (
            <div>
              <h6 className="text-uppercase text-muted fw-bold mb-2">POS</h6>
              <div className="row row-cols-2 g-2">
                <div className="col">
                  <NavLink to="pos" className={cardLinkStyle}>
                    Point de vente
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="cash" className={cardLinkStyle}>
                    Caisse
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="receipts" className={cardLinkStyle}>
                    Réceptions
                  </NavLink>
                </div>
              </div>
            </div>
          )}

          {/* Inventaire */}
          {canManager && (
            <div>
              <h6 className="text-uppercase text-muted fw-bold mb-2">
                Inventaire
              </h6>
              <div className="row row-cols-2 g-2">
                <div className="col">
                  <NavLink to="stock" className={cardLinkStyle}>
                    Stock
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="purchases" className={cardLinkStyle}>
                    Achats
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="purchase-orders" className={cardLinkStyle}>
                    Bons de commande
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="inventory" className={cardLinkStyle}>
                    Inventaire
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="/admin/shipments" className={cardLinkStyle}>
                    Shipments 
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="/dev/add-item" className={cardLinkStyle}>
                    Creer article 
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="https://generator-gilt.vercel.app/" className={cardLinkStyle}>
                    Gére barcodes
                  </NavLink>
                </div>
              </div>
            </div>
          )}

          {/* Administration */}
          {isAdmin && (
            <div>
              <h6 className="text-uppercase text-muted fw-bold mb-2">
                Administration
              </h6>
              <div className="row row-cols-2 g-2">
                <div className="col">
                  <NavLink to="roles" className={cardLinkStyle}>
                    Rôles
                  </NavLink>
                </div>
                <div className="col">
                  <NavLink to="/admin/cash-report" className={cardLinkStyle}>
                    Rapport de caisse
                  </NavLink>
                </div>
              </div>
            </div>
          )}
        </div>
      </aside>

      {/* Contenu principal */}
      <section className="col-12 col-lg-8 col-xl-9">
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body">
            <Outlet />
          </div>
        </div>
      </section>
    </div>
  );
}
